module.exports = __webpack_public_path__ + "assets/img/solar-panel-small.89da61e2.jpg";